import validate from "/home/jetmix/production/storebusters-landing/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45global from "/home/jetmix/production/storebusters-landing/middleware/route.global.ts";
export const globalMiddleware = [
  validate,
  route_45global
]
export const namedMiddleware = {}